import * as i0 from "@angular/core";
export class HomeLoginStore {
}
HomeLoginStore.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function HomeLoginStore_Factory() { return new HomeLoginStore(); }, token: HomeLoginStore, providedIn: "root" });
export var HomeLoginStoreKeys;
(function (HomeLoginStoreKeys) {
})(HomeLoginStoreKeys || (HomeLoginStoreKeys = {}));
